import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { CesionarioReceivedInvoiceDTO } from '../../interfaces/company-cesionario.interface';
import { MatTableDataSource } from '@angular/material/table';
import { ChangePaginationEvent, ChangeSortingEvent } from 'src/app/common/interfaces/paged-result.interface';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-received-invoices-table',
  templateUrl: './received-invoices-table.component.html',
  styleUrls: ['./received-invoices-table.component.scss']
})
export class ReceivedInvoicesTableComponent implements OnInit{
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<CesionarioReceivedInvoiceDTO>;
  public columns = [
    'folio',
    'fechaDocto',
    'montoTotal',
    'fechaCesion',
    'montoCesion',
    'proveedorRut',
    'proveedorName',
    'clienteRut',
    'clienteName'
  ]

  @Input() invoices: Array<CesionarioReceivedInvoiceDTO>;
  @Input() page: number = 1;
  @Input() pageSize: number = 5;
  @Input() totalRows: number;
  @Input() sortColumn: string;
  @Input() sortDirection: string;
  @Output() paginationChange = new EventEmitter<ChangePaginationEvent>;
  @Output() sortingChange = new EventEmitter<ChangeSortingEvent>;

  constructor() {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.setDataSource();
    this.setSorting();
  }

  public setDataSource(){
    this.dataSource.data = this.invoices;
    this.paginator.pageIndex = this.page - 1
    this.paginator.pageSize = this.pageSize;
    this.paginator.length = this.totalRows;
  }

  public setSorting(){
    this.sort.active = this.sortColumn;
    if(this.sortDirection){
      this.sort.direction = this.sortDirection === 'asc' ? 'asc' : 'desc';
    }
  }

  changePagination(pageEvent: PageEvent) {
    const changePagination: ChangePaginationEvent = {
      page: pageEvent.pageIndex + 1,
      pageSize: pageEvent.pageSize
    };
    this.paginationChange.emit(changePagination);
  }

  changeSorting(sort: Sort) {
    const sortEvent: ChangeSortingEvent = {
      sortColumn: sort.active,
      sortDirection: sort.direction.toLowerCase()
    };
    this.sortingChange.emit(sortEvent)
  }

}
